/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_PlaceholderInputs */

const en_us2_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search exercises, workouts, settings…`)
};

const pt_br2_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar exercícios, treinos, ajustes…`)
};

const es_419_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar ejercicios, entrenamientos, ajustes…`)
};

const pt_pt2_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar exercícios, treinos, definições…`)
};

const fr_fr2_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercices, séances, réglages…`)
};

const de_de2_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übungen, Trainings, Einstellungen suchen…`)
};

const it_it2_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca esercizi, allenamenti, impostazioni…`)
};

/**
* | output |
* | --- |
* | "Search exercises, workouts, settings…" |
*
* @param {Search_PlaceholderInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_placeholder = /** @type {((inputs?: Search_PlaceholderInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_PlaceholderInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_placeholder(inputs)
	if (locale === "es-419") return es_419_search_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_search_placeholder(inputs)
	if (locale === "fr-FR") return fr_fr2_search_placeholder(inputs)
	if (locale === "de-DE") return de_de2_search_placeholder(inputs)
	if (locale === "it-IT") return it_it2_search_placeholder(inputs)
	return en_us2_search_placeholder(inputs)
});
export { search_placeholder as "search.placeholder" }